import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () =>
      import(/* webpackChunkName: "home" */ '../views/home.vue')
  },
  {
    name: 'inviter',
    path: '/inviter',
    component: () =>
      import(/* webpackChunkName: "inviter" */ '../views/inviter.vue')
  },
  {
    name: 'invitee',
    path: '/invitee',
    component: () =>
      import(/* webpackChunkName: "invitee" */ '../views/invitee.vue')
  },
  {
    name: 'myinvite',
    path: '/myinvite',
    component: () =>
      import(/* webpackChunkName: "myinvite" */ '../views/myinvite.vue')
  },
  {
    path: '*',
    redirect: '/'
  }
]

// ${window.location.search}

const router = new Router({
  base: '/web-driver-invite',
  mode: 'history',
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  }
})

router.beforeEach((to, from, next) => {
  if (!to.fullPath.includes('?')) {
    const search = window.location.search
    const str = '?routerMode=history'
    return next(to.path + (search.length > 0 ? search : str))
  } else {
    next()
  }
})

export default router
